/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import styles from './BetPickTable.module.scss';
import { oddsDropBlock, RStatus, SCRRStatus, SCRStatus } from '@src/utils/kolBetpickUtils';

interface WinPLADataInter {
    combinedData: {
        horseList: [
            {
                no: string;
                status: string;
                name_ch: string;
                name_en: string;
                isBankerROw: boolean;
            }
        ];
        tableList: [
            {
                combString: string;
                horsename: string;
                QINHotFavourite: boolean;
                QINOddsValue: string;
                QINOddsDropValue: number;
                QPLHotFavourite: boolean;
                QPLOddsValue: string;
                QPLOddsDropValue: number;
            }
        ];
    };
    betTypeName: string;
    displayOdds: boolean;
    refundData: { WIN: boolean; PLA: boolean; QIN: boolean; QPL: boolean };
}

/** 用于betType为组合的样式 */
const BetPickTable = (props: WinPLADataInter) => {
    const { i18n, t } = useTranslation('kol');

    const lang = i18n.language === 'en-US';
    const { combinedData, betTypeName, displayOdds, refundData } = props;

    const header =
        betTypeName === 'QQP'
            ? [`${t('tableHorse')}`, `${t('Qin')}`, `${t('Qpl')}`]
            : [`${t('tableHorse')}`, `${betTypeName === 'QPL' ? `${t('Qpl')}` : `${t('Qin')}`}`];

    return (
        <div className={styles.BetPickTable}>
            <div className='flex justify-between border-b border-[#E0E0E0] pb-[6px] text-[11px] font-normal text-black'>
                <div>{t('horse')}</div>
            </div>
            <div className='flex items-start flex-col'>
                {combinedData?.horseList?.map((i, index) => {
                    const isSCR = SCRStatus.includes(i.status);
                    const isR = RStatus.includes(i.status);
                    const isSCRR = SCRRStatus.includes(i.status);

                    return (
                        <div
                            className='text-[13px] font-bold text-black mt-1 min-h-[20px] flex items-center'
                            key={index}
                        >
                            {i.isBankerROw && (
                                <div
                                    className={`${
                                        index < 2 ? 'bg-[#003C84]' : ''
                                    } text-white font-medium text-[10px] text-center min-w-[46px] h-[19px] leading-[19px] rounded-sm mr-2`}
                                >
                                    {index === 0 && t('betpick.banker')}
                                    {index === 1 && t('betpick.selection')}
                                </div>
                            )}
                            <div>
                                {`${i.no}. ${isR || isSCRR ? t('betpick.r') : ''}${
                                    lang ? i.name_en : i.name_ch
                                }`}
                                {(isSCR || isSCRR) && ` (${t('betpick.scratched')})`}
                            </div>
                        </div>
                    );
                })}
            </div>
            {displayOdds && combinedData?.tableList.length > 0 && (
                <table className='w-full  text-[14px] mt-[12px]'>
                    <thead>
                        <tr>
                            {header.map((i, index) => (
                                <th
                                    className={cn(
                                        'text-left text-[11px] font-medium',
                                        `${index === 0 ? 'text-left' : 'text-center'}`,
                                        `${header.length === 3 ? 'w-4/12' : ' w-2/4'}`
                                    )}
                                    key={index}
                                >
                                    <div>{i}</div>
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {combinedData?.tableList?.map((i, index) => {
                            const isQINSCR = i.QINOddsValue === 'SCR';
                            const isQPLSCR = i.QPLOddsValue === 'SCR';

                            const QINNoBG =
                                i.QINOddsValue === 'SCR' ||
                                i.QINOddsValue === '---' ||
                                refundData.QIN;
                            const QPLNoBG =
                                i.QPLOddsValue === 'SCR' ||
                                i.QPLOddsValue === '---' ||
                                refundData.QPL;

                            return (
                                <tr
                                    key={index}
                                    className='text-[13px] font-bold text-black pt-[5px] h-[20px]'
                                >
                                    <td className='text-left'>{i.horsename}</td>
                                    {betTypeName === 'QQP' ? (
                                        <>
                                            <td className={cn('text-center text-[#333]')}>
                                                <div
                                                    className={`px-1 inline-block min-w-[30px] ${
                                                        !QINNoBG &&
                                                        oddsDropBlock(
                                                            i.QINHotFavourite,
                                                            i.QINOddsDropValue
                                                        )
                                                    }`}
                                                >
                                                    {refundData.QIN
                                                        ? '---'
                                                        : isQINSCR
                                                        ? `${t('betpick.scratched')}`
                                                        : i.QINOddsValue}
                                                </div>
                                            </td>
                                            <td className={cn('text-center text-[#333]')}>
                                                <div
                                                    className={` px-1 inline-block min-w-[30px] ${
                                                        !QPLNoBG &&
                                                        oddsDropBlock(
                                                            i.QPLHotFavourite,
                                                            i.QPLOddsDropValue
                                                        )
                                                    }`}
                                                >
                                                    {refundData.QPL
                                                        ? '---'
                                                        : isQPLSCR
                                                        ? `${t('betpick.scratched')}`
                                                        : i.QPLOddsValue}
                                                </div>
                                            </td>
                                        </>
                                    ) : betTypeName === 'QIN' ? (
                                        <td className={cn('text-center text-[#333]')}>
                                            <div
                                                className={`px-1 inline-block min-w-[30px] ${
                                                    !QINNoBG &&
                                                    oddsDropBlock(
                                                        i.QINHotFavourite,
                                                        i.QINOddsDropValue
                                                    )
                                                }`}
                                            >
                                                {refundData.QIN
                                                    ? '---'
                                                    : isQINSCR
                                                    ? `${t('betpick.scratched')}`
                                                    : i.QINOddsValue}
                                            </div>
                                        </td>
                                    ) : (
                                        <td className={cn('text-center text-[#333]')}>
                                            <div
                                                className={`px-1 inline-block min-w-[30px] ${
                                                    !QPLNoBG &&
                                                    oddsDropBlock(
                                                        i.QPLHotFavourite,
                                                        i.QPLOddsDropValue
                                                    )
                                                }`}
                                            >
                                                {refundData.QPL
                                                    ? '---'
                                                    : isQPLSCR
                                                    ? `${t('betpick.scratched')}`
                                                    : i.QPLOddsValue}
                                            </div>
                                        </td>
                                    )}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default memo(BetPickTable);
